import { string } from '../../typing/string.js';
import { object } from '../../typing/object.js';
import { literal } from '../../typing/literal.js';

export const AuthDeviceCodeResponse = object('AuthDeviceCodeResponse', {
  type: literal('code'),
  url: string(),
  userCode: string(),
});
